import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import syntax from './assets/images/syntax.png';
import selectorExample from './assets/images/selector-example.png';
import selectorExample2 from './assets/images/selector-example2.png';

const CSSLesson6 = () => {
  const [language, changeLanguage] = useState("css");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
   p {
     text-align: center;
     color: red;
   }
  `
  );
  const code2 = (
  'text',
  `
   .center {
    text-align: center;
    color: red
   }
  `
  );
  const code3 = (
  'text',
  `
   #center {
    text-align: center;
    color: red
   }
  `
  );
  const code4 = (
  'text',
  `
  p {
    text-align: center;
    color: red;
  }
 `
  );
  return (
    <HTMLCourseNavProvider>
      <div className="container">
        <div className="row">
          <div>
            <SideBar />
          </div>
          <h3><strong>Syntax and Selectors</strong></h3>
    <p>A CSS rule-set consists of a selector and a declaration block</p>
    <p>The selector points to the HTML element you want to style. The declaration block contains one or more declarations separated by semicolons.</p>
    <p>Each declaration includes a CSS property name and a value, separated by a colon. A CSS declaration always ends with a semicolon, and declaration blocks are surrounded by curly braces.</p>
    <CopyBlock
    language={language}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />

    
    <h3 className="mt-3">CSS Selectors</h3>
    <p>CSS selectors are used to "find" (or select) HTML elements based on their element name, id, class, attribute, and more.</p><br/>

    <div className="alert alert-secondary" role="alert">
    <h4><strong>Element Selector</strong></h4>
     <p>The element selector selects elements based on the element name.</p>
     <p>You can select all <b class="text-danger">&lt;p&gt;</b> elements on a page like this (in this case, all <b class="text-danger">&lt;p&gt;</b> elements will be center-aligned, with a red text color):</p>
      
     <CopyBlock
    language={language}
    text={code4}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />

         </div>
    <div className="alert alert-secondary" role="alert">
     <h4><strong>The id Selector</strong></h4>
     <p>The id selector uses the id attribute of an HTML element to select a specific element.</p>
     <p>The id of an element should be unique within a page, so the id selector is used to select one unique element!</p>
    <p>To select an element with a specific id, write a hash <b class="text-danger">(#)</b> character, followed by the id of the element.</p><br/>
    <CopyBlock
    language={language}
    text={code3}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>
    <div className="alert alert-secondary" role="alert">
    <h4><strong>The class Selector</strong></h4>
    <p>The class selector selects elements with a specific class attribute.</p>
    <p>To select elements with a specific class, write a period (.) character, followed by the name of the class.</p>
    <CopyBlock
    language={language}
    text={code2}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
  </div>



          </div>
        </div>
    </HTMLCourseNavProvider>
  );
};

export default CSSLesson6;
